import React from 'react';

import styles from './Breadcrumbs.scss';
import BackLink from 'Components/BackLink';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import { ROUTES } from '../../settings/route-strings';

const getBackLabelMessageId = route => {
  switch (route) {
    case ROUTES.EXPLORE:
      return 'breadcrumbs.back_label.explore';
    case ROUTES.CLASSES:
      return 'breadcrumbs.back_label.classes';
    default:
      return null;
  }
};

const Breadcrumbs = ({ title, id, route, modifierClass }) => {
  let className = `Breadcrumbs Breadcrumbs--${id}`;
  if (modifierClass) className += ` Breadcrumbs--${modifierClass}`;
  const labelId = getBackLabelMessageId(route);
  return (
    <div className={className}>
      <div className="Breadcrumbs__container">
        <BackLink
          type={id}
          label={labelId ? <ConnectedFormattedMessage id={labelId} /> : null}
          route={route}
        />
        {title ? <div className="Breadcrumbs__title">{title}</div> : null}
      </div>
    </div>
  );
};

export default Breadcrumbs;
